import { createSelector } from 'reselect';

const selectAllDepartments = state => state.departments;

export const selectDepartments = createSelector(
    [selectAllDepartments],
    department => department.departments
)
export const selectIsFetchingDepartments = createSelector(
    [selectAllDepartments],
    department => department.isFetchingDepartments
)

export const selectIsLoadingDepartments = createSelector( //change for all departments
    [selectAllDepartments],
    department => department.isFetchingDepartments
)

export const selectDepartmentsOnPage = createSelector(
    [selectAllDepartments],
    department => department.departmentsOnPage
)

export const selectSearchDepartmentsQuery = createSelector(
    [selectAllDepartments],
    department => department.searchDepartmentsQuery
)


export const selectSelectedDepartments = createSelector(
    [selectAllDepartments],
    department => department.selectedDepartments
)

export const selectNumDepartments = createSelector(
    [selectAllDepartments],
    department => department.numDepartments
)
